<template>
  <div>
    <h2>Accesos</h2>
    <div>
      De acuerdo a los tags seleccionados, los siguientes roles y
      usuarios tendrán acceso a esta empresa
    </div>
    <div
      v-for="(role, roleIndex) in rolesAndUsers"
      :key="roleIndex"
      style="margin-top: 20px"
    >
      <div>
        <b>{{ role.name }}</b>
      </div>
      <div
        v-for="(user, userIndex) in role.userAccounts"
        :key="userIndex"
        style="padding-left: 15px"
      >
        {{ user.firstName }} {{ user.lastName }} ({{
          user.username
        }})
      </div>
    </div>
    <template v-if="!rolesAndUsers.length">
      <template v-if="!getAllStoreInfo.tagsToCreate">
        <div
          v-if="
                        !getAllStoreInfo.tags ||
                        !getAllStoreInfo.tags.selected.length
                      "
          class="message-error"
        >
          No se creo ni se seleccionó ningún Tag. A menos de que
          cree roles y usuarios, esta empresa no será accesible por
          ningún usuario existente.
        </div>
      </template>
    </template>
  </div>
</template>
<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { mapGetters } from "vuex";
import {axiosCall} from "@/utils/axiosCall";

export default {
  name: "GivenAccess",
  props: {
  },
  data(){return{
    rolesAndUsers:[]
  }},
  methods: {
    getPermissions: async function () {
      if (
        this.getAllStoreInfo.tags &&
        this.getAllStoreInfo.tags.selected &&
        this.getAllStoreInfo.tags.selected.length
      ) {
        await axiosCall({
          url: `AccessControls/getPermissions`,
          method: "post",
          data: this.getAllStoreInfo.tags.selected,
        }).then((response) => {
          this.rolesAndUsers = response.data.accountRoles;
          this.$forceUpdate();
        });
      }
      return true;
    },
  },
  mounted() {
    this.getPermissions()
  },
  computed: {
    ...mapGetters(["getAllStoreInfo"]),
  },
};
</script>

<style lang="scss" scoped>
.new-id {
  font-size: 11px;
  color: gray;
}

.error {
  color: red;
}

.ok {
  color: green;
}

.message-error {
  font-size: 16px;
  color: red;
  text-align: center;
  padding: 30px;
}

.delete-tab {
  color: red;
  font-weight: bold;
  margin-left: 5px;
  padding: 2px 5px;
  font-size: 15px;
  transition: 0.3s;

  &:hover {
    font-size: 13px;
  }
}
</style>
